import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { request } from "./request";
import { AuthenticationContext } from "../context";

export interface Authenticator {
  readonly id: number,
  readonly user_account_data_id: number,
  readonly identity: string,
  readonly authenticator: string,
  readonly created_at: string,
  readonly last_authenticated_date: string,
}

export interface AuthenticatorsResponse {
  readonly results: Authenticator[],
}

export interface validAuthenticatorsResponse {
  readonly authenticators: Authenticator[],
}

export const listAuthenticators = async(authToken: string) => {
  return request<Object, AuthenticatorsResponse>({
    endpoint: "/user/account_authenticators_list",
    body: {},
  }, authToken);
};

export const useListAuthenticatorsQuery = () => {
  const { getAuthToken } = useContext(AuthenticationContext);

  const query = useQuery({
    queryFn: async () => {
      return listAuthenticators(await getAuthToken());
    },
    queryKey: ["authenticators"],
    staleTime: 300,
    retry: false,
  });

  return query;
};

export const listValidAuthenticators = async(authToken: string) => {
  return request<Object, validAuthenticatorsResponse>({
    endpoint: "/member/notification_settings_get_valid_authenticators",
    body: {},
  }, authToken);
};

export const useListValidAuthenticatorsQuery = () => {
  const { getAuthToken } = useContext(AuthenticationContext);

  const query = useQuery({
    queryFn: async () => {
      return listValidAuthenticators(await getAuthToken());
    },
    queryKey: ["validAuthenticators"],
    staleTime: 300,
    retry: false,
  });

  return query;
};

export interface LoginPreferences {
  readonly id: number,
  readonly identity: string,
  readonly plan_id: string,
  readonly client_id: string,
  readonly external_member_id: string,
  readonly person_code: string,
  readonly authenticator: string,
  readonly allow_optional: boolean,
}

export const getAccountPreferences = async(authToken: string) => {
  return request<Object, LoginPreferences>({
    endpoint: "/user/login_preferences_get",
    body: {},
  }, authToken);
};

export const useGetAccountPreferencesQuery = () => {
  const { getAuthToken } = useContext(AuthenticationContext);

  const query = useQuery({
    queryFn: async () => {
      return getAccountPreferences(await getAuthToken());
    },
    queryKey: ["preferences"],
    staleTime: 300,
    retry: false,
  });

  return query;
};
